import {ComponentData} from "../../engine/tools/EntityManager";

export class Input implements ComponentData {

    active: boolean = true
    input: number = 0
    lastInput: number = 0

    constructor(options?: Partial<Input>) {
        Object.assign(this, options)
    }
}